import React from 'react';
import styled from 'styled-components';

type DividerComponentProps = {
  color?: string
  mt?: string
  mb?: string
  height?: string
}

const DividerStyle = styled.div<{$color?: string, $mt?:string, $mb?: string, $height?: string}>`
  background-color: ${props => props.$color || '#f2f0e9'};
  margin-top: ${props => props.$mt || '0'};
  margin-bottom: ${props => props.$mb || '0'};
  height: ${props => props.$height || '1px'};
`;

const Divider: React.FC<DividerComponentProps> = ({ color, mt, mb, height }) => {
  return (
    <DividerStyle $color={color} $mt={mt} $mb={mb} $height={height} />
  );
};

export default Divider;
